import { createLayoutApp } from "../layout/createLayoutApp";
import HotelDetails from "../hotelDetails/HotelDetails.vue";
import { setDocumentControllerType } from "../util/controllerHelpers";

const mountEl = document.getElementById("hotel-details-page-app");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");

  const raw = mountEl.getAttribute("data-view-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const showInfrastructureTab = mountEl.getAttribute("data-showInfrastructureTab") === "True" ||
    mountEl.getAttribute("data-showInfrastructureTab") === "true";
  const showNewsTab = mountEl.getAttribute("data-showNewsTab") === "True" ||
    mountEl.getAttribute("data-showNewsTab") === "true";

  const app = createLayoutApp(HotelDetails, {
    viewModel,
    showInfrastructureTab,
    showNewsTab,
  });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}